import styled from 'styled-components';
import { getSpacingToken, Stack } from '@optimus-web/core';

export const TitleStack = styled(Stack)`
    min-width: 0;
    padding-top: ${getSpacingToken('50')}px;
`;
